module.exports = __webpack_public_path__ + "static/media/Item_Weapon_FlashBang_C.f77d2d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_FlashBang_C.png
// module id = 430
// module chunks = 0